import { memo } from 'react';
import { SvgIcon } from '@mui/material';

import { Icon as IconType } from './interfaces';

interface Props {
  icon: IconType;
  className?: string;
}

const Icon = ({ icon, className }: Props) => <SvgIcon className={className} component={icon} />;

export default memo(Icon);
